import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';
import { Roles, IxellAPIService, StatsFeatureType } from 'src/app/tools/api.service';
import { StorageService } from '../../tools/storage.service';


@Component({
    selector: 'laca_actionmateriel',
    templateUrl: './action-materiel.component.html',
    styleUrls: ['./action-materiel.component.scss']
})
export class ActionMaterielComponent implements OnInit {

    Utils = Utils;
    scale: string;

    private roleSub: any;
    private tutoSub: any;

    private statsLogFeatureSub: any;

    role: Roles = Roles.Unknown;
    urlPortailTuto: string = "";

    constructor(private headerService: HeaderService, private storage: StorageService, private api: IxellAPIService) { }

    ngOnInit() {
        this.headerService.changeTitle("support.supportAssistance");
        this.headerService.changeCanBack(true);
        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role
        }, error => {
            console.log(error);
            if (this.roleSub != null) this.roleSub.unsubscribe();
        });
        this.scale = this.storage.get('scale');
        let code: string;
        this.tutoSub = this.api.getUrlPortailTuto(code).subscribe(data => this.urlPortailTuto = data);
    }

    ngOnDestroy() {
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.tutoSub != null) this.tutoSub.unsubscribe();
        if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
    }

    faq() {
        this.statsLogFeatureSub = this.api.statsLogFeature(StatsFeatureType.ViewFAQ).subscribe(() => {
            if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
        });

        window.open(this.urlPortailTuto, "_blank");
    }
}
